module.exports = __webpack_public_path__ + "assets/normal/images/reset-permission.c2084df2.png";